import { Code, Spoiler } from "@mantine/core";

/** Raw-JSON expander for the full document (every detail screen carries one). */
export function JsonExpander({ value }: { value: unknown }) {
  const json = JSON.stringify(value, null, 2);
  return (
    <Spoiler maxHeight={0} showLabel="Show raw JSON" hideLabel="Hide raw JSON">
      <Code block style={{ whiteSpace: "pre", fontSize: 12, maxHeight: 480, overflow: "auto" }}>
        {json}
      </Code>
    </Spoiler>
  );
}
